import { Origin } from "@/openapi/generated";

/** Origin for mutations initiated from admin vs parent (member) portal. */
export function portalMutationOrigin(adminPortal: boolean): Origin {
  return adminPortal ? Origin.Admin : Origin.Member;
}
